export function inTestEnvironment(): boolean {
  return getEnvironment() === 'test'
}

export function inDevEnvironment(): boolean {
  return getEnvironment() === 'development'
}

export function inLocalEnvironment(): boolean {
  return inDevEnvironment() || inTestEnvironment()
}

export function inStagingEnvironment(): boolean {
  return getEnvironment() === 'staging'
}

/** False while a module is evaluated by the Inertia SSR server, which has neither window nor document. */
export function inBrowser(): boolean {
  return typeof document !== 'undefined'
}

export function getEnvironment(): string | null {
  return document.body.getAttribute('data-env')
}

export function getPartnerKey(): string | null {
  return document.body.getAttribute('partner-key')
}

export function getEmbedParent(): string | null {
  return document.body.getAttribute('embed-parent')
}
